<template>
    <div>
        <div class="row align-items-center">
            <div class="col-1 d-none d-md-block">
                <div class="prev-action-wrapper square-action-wrapper text-center" @click="prevEpisode()" v-if="episodes.length > 1">
                    <caretleft></caretleft>
                    <div class="small-uppercase mt-1">Previous Episode</div>
                </div>
            </div>
            <div class="col-12 col-md-10">
                <div class="video-title pl-0 pl-md-4">
                    <h5 class="mb-2">
                        <television class="mr-2"></television>
                        <span v-if="episodes[currentIndex].episode">{{ 'E' + episodeNumberFormat(episodes[currentIndex].episode) + ' - ' }}</span>
                        {{ episodes[currentIndex].episode_title }}
                    </h5>
                </div>
                <div class="videoPlayer">
                    <div class="videoholder" :class="(index == currentIndex) ? 'active' : 'hide-me' " :id="'videoHolder' + index" v-for="(episode, index) in episodes"></div>
                </div>
            </div>
            <div class="col-1 d-none d-md-block">
                <div class="next-action-wrapper square-action-wrapper text-center"  @click="nextEpisode()" v-if="episodes.length > 1">
                    <caretright></caretright>
                    <div class="small-uppercase mt-1">Next Episode</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import caretleft from './icons/caret_left.vue';
import caretright from './icons/caret_right.vue';
import Television from "../Icons/television.vue";

export default {
    name: "VideoEpisodeViewer",
    components: {Television, caretleft, caretright},
    props: ['episodes', 'episode_to_show'],
    data() {
        return {
            source: '',
            currentIndex: this.episode_to_show,
            totalVideos: '',
            myPlayer: '',
            playerHTML: {},
            playerData: {
                accountId: "1483464688001",
                playerId: "default"
            }
        }
    },
    mounted: function() {
        this.totalVideos = this.episodes.length;
        this.addPlayer();
    },
    created: function() {
        this.currentIndex = this.episode_to_show;
    },
    watch: {
        episode_to_show: function () {
            this.pauseVideo();
            this.currentIndex = this.episode_to_show
        }
    },
    methods: {
        addPlayer: function() {
            let app = this;

            // Dynamically build the player video element
            // Doing this  so we don't fight with VueJS and the <video-js> of brightcove
            app.episodes.forEach(function (value, index) {
                app.playerHTML[index] =
                    '<video-js id="myPlayerID' + index + '" data-video-id="' +
                    value.asset_id +
                    '"  data-account="' +
                    app.playerData.accountId +
                    '" data-player="' +
                    app.playerData.playerId +
                    '" data-embed="default" class="video-js" controls></video-js>';
                // Inject the player code into the DOM
                document.getElementById("videoHolder" + index).innerHTML = app.playerHTML[index];
            });


            // Add and execute the player script tag
            var s = document.createElement("script");
            s.src = "https://players.brightcove.net/" + app.playerData.accountId + "/" + app.playerData.playerId + "_default/index.min.js";
            // Add the script tag to the document
            document.body.appendChild(s);
        },
        pauseVideo: function() {
            let app = this;
            app.myPlayer = bc("myPlayerID" + app.currentIndex);
            app.myPlayer.pause();
        },
        playVideo: function() {
            let app = this;
            app.myPlayer = bc("myPlayerID" + app.currentIndex);
            app.myPlayer.play();
        },
        prevEpisode: function() {
            let app = this;
            app.pauseVideo();
            if(app.currentIndex > 0) {
                app.currentIndex--;
            } else {
                app.currentIndex = app.totalVideos - 1;
            }
            this.$emit('episodeUpdated', app.currentIndex);
        },
        nextEpisode: function() {
            let app = this;
            app.pauseVideo();
            if(app.currentIndex < (app.totalVideos - 1)) {
                app.currentIndex++;
            } else {
                app.currentIndex = 0;
            }
            this.$emit('episodeUpdated', app.currentIndex);
        },
        clickEpisode: function(episodeClicked) {
            let app = this;
            app.pauseVideo();
            app.currentIndex = 0;
        },
        episodeNumberFormat: function(episode) {
            if(episode < 10) {
                return '0' + episode;
            }
            return episode;
        }
    }
}
</script>
<style lang="scss">
.bmpui-ui-watermark {
    display:none;
}
.bmpui-ui-recommendation-overlay {

}
</style>
